import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ApplicationService } from "app/services/application.service";
import { CarrierService } from "app/services/carrier.service";
import { PermitTypeDocumentService } from "app/services/permit-type-document.service";
import { RouteService } from "app/services/route.service";
import { UtilityServiceService } from "app/services/utility-service.service";
import { DatePipe } from '@angular/common';
import { VehicleService } from "app/services/vehicle.service";
import { environment } from "environments/environment";
import { accounting } from 'accounting';
import { PermitService } from "app/services/permit.service";
import { PermitTypeService } from "app/services/permit-type.service";
import { CountryService } from "app/services/country.service";
import { PopupService } from "app/services/shared/popup.service";
import { DomSanitizer } from "@angular/platform-browser";
import { CorspdcService } from "app/services/corspdc.service";
import { ToastrService } from "ngx-toastr";
import { VehicleMakeService } from "app/services/vehicle-make.service";
import { AuthWebService } from "app/services/authweb.service";
import { CarrierAccountService } from "app/services/carrier-account.service";
import { AnyMxRecord } from "dns";
import { CompliancereturnsService } from "app/services/compliancereturns.service";
import { ConfirmDialogService } from "app/services/shared/confirm-dialog/confirm-dialog.service";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";
var jsPDF = require('jspdf');
require('jspdf-autotable');
declare var $;

@Component({
    selector: 'c-confirmation',
    templateUrl: './c-confirmation.component.html',
    styleUrls: ['./c-confirmation.component.css'],
    providers: [PermitTypeDocumentService, RouteService]
  })

  export class CConfirmationComponent implements OnInit {
    public isLoading = false;
    helphtml;
    linkhtml;
    @Input() dataCntrl: any;
    userDetails: any = null;
    totalFee: any = "";
    termsFlag: boolean = false;
    public pageload = false;

    enabledBtnsFlag: boolean = false;
    @ViewChild('content', { static: true }) content: ElementRef;
    status_id: number;
    email_body = "";
    decl_date = new Date();
    vehicles: any = [];
    lineTotal: any ="";
    isProcess: boolean = true;
    submissionAmt: any = 0;
    paidAmt: any = 0;
    invoiceNumber: any = "";
    invoiceRes: any = null;
    dueAmt: any = 0;
    chargeInd: any = 0;
    renewCrId: any = "";
    renewFlag: boolean = false;
    country
    linkedDocs: any = [];
    listvehicles: any = [];
    myLoader: boolean = false;
    list_vehicle_make: any;
    selectedVMake: any;
    ownRoutes: any = [];
    count: any = 0;
    carrier_account_id: any = 0;
    debtorAccountId: any;
    accBalance: any = 0;
    permitRenewal: boolean = false;
    hasCredit: boolean =false;
    inTransaction: boolean= false;
    enablePayment: boolean= false;
    permitStatus1: number;
    permitStatus2: number;
    permitStatus6: number;
    permitStatus4: number;
    permitStatus7: number;
    permitStatus10: number;
    permitStatus13: number;
    permitStatus14: number;
  
    branch: any = "X";
    message: any = "Processing. Please wait...";
  
    ptype: any = null;
    ptypeDays: any = null;
    ptypeMonth: any = null;
    ptypeYears: any = null;
    isAmmendRoute:boolean=false;
    isCompletePayment: boolean=false;  
    newStatus: number;
    permit_Type:any;
    permit_fee : any;
    application_fee : any;
    applicationId : any;
    Compliance_PermitType_Id:any = 0;
    isView : boolean = false;
    //permTypeToUse : any;
    @Input('isAnnualCompliance') isAnnualCompliance : boolean = false;

    constructor(private sanitizer: DomSanitizer,private complianceService: CompliancereturnsService, private showModal: PopupService, private toastr: ToastrService,
        private applicationService: ApplicationService, public utility: UtilityServiceService, private permitService: PermitService,private toastService:ToastNotificationService,
        private router: Router, private vehicleService: VehicleService, private vehicleMakeService: VehicleMakeService,
        private carrierService: CarrierService, private crspdService: CorspdcService, private routeService: RouteService,
        private activeRoute: ActivatedRoute,
        // public currformat: CurrencyFormat,
        private authWebService: AuthWebService,
        private countryService: CountryService,
        private service: PermitTypeDocumentService,
        private carrieraccountserver: CarrierAccountService,
        private datePipe: DatePipe, 
        private permitSevc: PermitService,private permittypeService: PermitTypeService,private confirmDialogService: ConfirmDialogService)   {}

    async ngOnInit(){
      //alert(this.dataCntrl.compID);
        //this.disbledBtn();
        this.isView = this.router.url.indexOf('isView') > 0;

        this.userDetails = environment.authWebApi.userData.User;
        console.log(this.userDetails)
        this.dataCntrl.application.id = this.dataCntrl.appID;
         
        this.myLoader = true;
        this.activeRoute.params.subscribe((params: Params) => {
          this.dataCntrl.carrierID = params['carrierid'];
          // this.calendarid = params['calendarid'];
        });
        this.toastr.clear();
        this.setHTMLDATA();
        //await this.getCarrier();
        
        if (environment.authWebApi.systemData != null && environment.authWebApi.systemData.Configurations != null) {
            this.permitStatus1 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus1').Value;
            this.permitStatus2 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus2').Value;
            this.permitStatus4 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus4').Value;
            this.permitStatus6 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus6').Value;
            this.permitStatus7 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus7').Value;
            this.permitStatus10 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus10').Value;
            this.permitStatus13 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus13').Value;
            this.permitStatus14 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus14').Value;
          }
          this.userDetails = environment.authWebApi.userData.User;
          this.isCompletePayment = this.router.url.indexOf('completepayment') > 0
          if (this.isCompletePayment == true) {
            this.utility.confirmCtrl = false
          }
          this.activeRoute.params.subscribe(async (params: Params) => {
            if (params['type']) {
              this.renewFlag = true;
              this.renewCrId = params['crId'];
            }
            if(params['ctrlType']=='true'){
              this.isAmmendRoute=true;
              this.getOldStartDate();          // BUG : 121
            }
            if (this.dataCntrl.application.id == null || this.dataCntrl.application.id == undefined) {
              this.dataCntrl.application.id = params['id'];
            } else {
              this.dataCntrl.application.id = this.dataCntrl.permits[0].application_id;
            }
            await this.getApplication();
            await this.getCompliancePermitType();
            await this.getVehicleMake();
            await this.getSavedVehicleByPermit();
            
            //this.getCarrier();
            
     
             });
           this.CheckConfirmDetails();
    }
    // formatCurrency(value) {
    //     return "R";
    //   }
     //   formatCurrency(value) {
    //     return accounting.formatMoney(value, 'R', 2, ' ', '.');
    //   }
  
      checkTerms(event) {
        if (event.target.checked) {
          this.termsFlag = true;
        } else {
          this.termsFlag = false;
        }
        this.disbledBtn();
      } 

      getPermitType() : Promise<any>
      {
        //alert('getsomething');
        return this.permittypeService.getById(this.dataCntrl.permittype.Compliance_PermitType_Id).toPromise();
      }
      async getCompliancePermitType()
      {
        //alert('getCompliancePermitType');
        if(this.isAnnualCompliance)
        {
          
          ////alert(this.dataCntrl.permittype.Compliance_PermitType_Id);
        //this.permittypeService.getById(this.dataCntrl.permittype.Compliance_PermitType_Id).subscribe(permType=>{
          //this.permTypeToUse = permType; 
          var permType = await this.getPermitType(); 
         this.permit_Type = permType;
         //alert("permType returned");
            this.permit_fee =  permType.current_fee;
            this.application_fee =  permType.current_application_fee;
            this.lineTotal = this.permit_fee + this.application_fee;
            
          //});
      }
      }

      getApplicationById() : Promise<any>
      {
        return this.applicationService.getById(this.dataCntrl.appID).toPromise();
      }
     async getApplication() {
       //alert("getApplication");
        this.pageload = true;
    
        if (this.dataCntrl.appID !== null && this.dataCntrl.appID !== undefined) {
          //this.applicationService.getById(this.dataCntrl.appID).subscribe(data => {
            var data = await this.getApplicationById();
            //alert(JSON.stringify(data));
              //this.dataCntrl = data;
              this.isProcess = true;
              this.CheckConfirmDetails();
              this.dataCntrl.permittype = data.permit_type;
              this.utility.timetableActive = data.permit_type.timetable_reqd;
              if (data.permit_type.timetable_reqd) {
                this.utility.sequenceNumbers.permitNum = 1;
                this.utility.sequenceNumbers.vehicleNum = 2;
                this.utility.sequenceNumbers.routesNum = 3;
                this.utility.sequenceNumbers.motivationNum = 4;
                this.utility.sequenceNumbers.timeTableNum = 5;
                this.utility.sequenceNumbers.uploadsNum = 6;
                this.utility.sequenceNumbers.cnfNum = 7;
                this.utility.activeTab = 7;
              } else {
                this.utility.sequenceNumbers.permitNum = 1;
                this.utility.sequenceNumbers.vehicleNum = 2;
                this.utility.sequenceNumbers.routesNum = 3;
                this.utility.sequenceNumbers.motivationNum = 4;
                this.utility.sequenceNumbers.uploadsNum = 5;
                this.utility.sequenceNumbers.cnfNum = 6;
              }
              this.userDetails = environment.authWebApi.userData.User;
              //console.log(this.userDetails)
              this.application_fee =  data.permits[0].application_fee;
              this.permit_fee = data.permits[0].permit_fee
              this.lineTotal = (this.application_fee + this.permit_fee );
              // this.lineTotal = this.lineTotal;
                // this.totalFee = this.totalFee;
                this.pageload = false;
                //await this.getCarrier();
              
            // this.dataCntrl.permits[0].permit_fee =  this.dataCntrl.permittype.current_fee;
            // this.dataCntrl.permits[0].application_fee =  this.dataCntrl.permittype.current_application_fee;
            // this.vehicles = [];
            this.dataCntrl.application = data;
            this.applicationId = data.id;
            this.dataCntrl.carrierID = data.carrier_id;
            this.dataCntrl.permit_type_id =data.permit_type.Compliance_PermitType_Id;
            // this.dataCntrl.permit=data.permit;
            this.dataCntrl.permittype = data.permit_type;
            //this.dataCntrl.vehicles=this.dataCntrl.application.vehicle;
            this.carrier_account_id = data.carrier_account_id;
    
    
           await  this.getCarrier();
            //this.getSavedVehicleByPermit();
            //this.getCompliancePermitType();
            
          // }, error => {
          //   this.pageload = false;
          // })
        } else {
          this.getCarrier();
        }
        this.pageload = false;
        this.getCorrectionPermitType();
      }

      getCarrierById() : Promise<any>
      {
        //alert(this.dataCntrl.carrierID);
        return this.carrierService.getById(this.dataCntrl.carrierID).toPromise();
      }
      async getCarrier() {
        //alert('getCarrier');
        this.pageload = true;

        //this.carrierService.getById(this.dataCntrl.carrierID).subscribe(result => {
          var result = await this.getCarrierById();
        this.setDebtorAccount(result.carrier_account_id);
          this.setCarrierData(result);
          //alert(1);
          this.pageload = false;
        // }, error => {
        //   this.pageload = false;
        // });
      }

      setDebtorAccount(carrierAccountId) {
        this.carrierService.getDebtorAccount(carrierAccountId).subscribe((result:any) => {
          this.debtorAccountId = result.customer_code;
        }, error => {
        });
      }
    
      listCountries(id) {
        this.countryService.listCountries().subscribe((result:any) => {
          if (id != null) {
            this.country = result.find(x => x.id == id);
            this.country = this.country.desc;
          }
        }, error => {
          this.isLoading = false;
        });
      }
      getCorrectionPermitType(){
        this.permittypeService.getById(this.dataCntrl.permit_type_id).subscribe((type:any) =>{
          this.ptype = type;
          if(type.permit_days > 0){
            this.ptypeDays = type.permit_days;
          }
          if(type.permit_months > 0){
            this.ptypeMonth = type.permit_months;
          }
          if(type.permit_years > 0){
            this.ptypeYears = type.permit_years;
          }
        })
      }
      setCarrierData(data) {
        if (data.account_balance != null) {
          this.accBalance = data.account_balance * -1;
          if (!data.account_balance.toString().includes("R")) {
            if (parseFloat(data.account_balance) != 0) {
              data.account_balance = -(parseFloat(data.account_balance));
            }
            data.account_balance = data.account_balance != 0 ? parseFloat(data.account_balance) : 'R 0.00';
          }
        }
        this.dataCntrl.carrier = data;
        $("#carrierName").html(data.name);
        this.listCountries(data.country_id);
      }
    
      saveConfirmation(permitStatus) {  
        this.updateConfm(permitStatus);      
      }
    
      PermitDetailsConfirmation() {
        if (this.branch == 'C') {
          this.UpdatepermitStatus(this.permitStatus14);
        }
    
        if (this.branch == 'F') {
          this.UpdatepermitStatus(this.permitStatus10);
          this.carrieraccountserver.ResendAccountLinkingOTP(this.dataCntrl.person, this.dataCntrl.person_id);
        }
      }
      
     
    
      CheckConfirmDetails() {
        //changes and owes money
        this.activeRoute.params.subscribe((params: Params) => {
          if(params['constatus'] == 2){
            if ((this.dataCntrl.permits[0].application_invoice_link == null || this.dataCntrl.permits[0].permit_invoice_link == null) && (this.applicationService.documentsChanged || this.applicationService.motivationChanged || this.applicationService.vehicleAdded)) {
              this.branch = "A";
              this.isProcess = true;
    
            }
    
            //changes and dont owe money
            if (this.dataCntrl.permits[0].application_invoice_link == null && this.dataCntrl.permits[0].permit_invoice_link == null && (!this.applicationService.documentsChanged || !this.applicationService.motivationChanged || !this.applicationService.vehicleAdded)) {
              this.branch = "C";
            }
    
            //No change and owes money
            if (this.dataCntrl.permits[0].application_invoice_link == null || this.dataCntrl.permits[0].permit_invoice_link == null && (!this.applicationService.documentsChanged || !this.applicationService.motivationChanged || !this.applicationService.vehicleAdded)) {
              this.branch = "E";
              this.isProcess = true;
            }
    
            //No Changes and dont owe money
            if (this.dataCntrl.permits[0].application_invoice_link != null && this.dataCntrl.permits[0].permit_invoice_link != null && (!this.applicationService.documentsChanged && !this.applicationService.motivationChanged && !this.applicationService.vehicleAdded)) {
              this.branch = "F";
            }
          }         
        });
      }
    
      //Update Permit Status
      UpdatepermitStatus(status_id) {
        this.dataCntrl.permits[0].status_id = status_id;
        this.permitService.upadatePermit(this.dataCntrl.permit).subscribe(result => {
          this.dataCntrl.permit = result;
          // this.toastr.success('Updated Permit Type Successfully','Permit Type');
          // this.applicationService.setTab(2);
    
        })
      }
    
      updateConfm1() {
        this.pageload = true;
        if (!this.termsFlag && !this.isCompletePayment) {
          this.pageload = false;
          return this.toastService.error('Please agree the terms','Terms');
        }

        
        this.permitService.saveToCorspdc(this.dataCntrl.carrier.id, this.userDetails.FirstName).subscribe(result => {
          this.pageload = false;
          this.isLoading = false;
    
          if (result == true) {
            this.retrieveSubmitStatus();
    
            this.sendCorr(1);
    
    
            //this.dialogService.addDialog(AlertComponent, { title: `Carrier Account Submission`, message: `Carrier Account with registration number  ${this.caConfirmObj.registration_number} submitted successfully.`, bold: `${this.caConfirmObj.registration_number}` });
            //this.utility.activeTab = 1;
          } else {
            this.sendCorr(0)
            this.pageload = false;
            this.toastService.error(`Submission for   failed.Please contact the system administrator if the problem persists.`,'Error');
          }
        }, error => {
          this.pageload = false;
          this.isLoading = false;
          this.toastService.error(`Submission for failed.Please contact the system administrator if the problem persists.`,'Error');
          //this.dialogService.addDialog(AlertComponent, { title: `Carrier Account Submission`, message: `Submission for  ${this.caConfirmObj.registration_number} failed.Please contact the system administrator if the problem persists.`, bold: `${obj.registered_name}` });
    
        });
      }
      setHTMLDATA() {
    
        if (environment.authWebApi.systemData != null) {
          this.linkhtml = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'HTMLDec2');
          // this.linkhtml = this.sanitizer.bypassSecurityTrustHtml(link.Value);
        }
      }
      retrieveSubmitStatus() {
        if (this.authWebService.userData) {
    
          if (this.branch == "A" || this.branch == "C") {
            this.status_id = this.permitStatus14
          }
          else if (this.branch == "E") {
            this.status_id = this.permitStatus7;
          }
          else if (this.branch == "F") {
            this.status_id = this.permitStatus10;
          }
          else {
            this.status_id = + environment.authWebApi.systemData.Configurations.find(config => config.Code == "AccountStatus2").Value;
          }
    
          this.dataCntrl.application.status_id = this.status_id;
          this.dataCntrl.application.submission_date = new Date();
          // if(this.vehicles==null || this.vehicles.length==0){
          //   this.dataCntrl.application.total_fees=parseInt(this.dataCntrl['permits'][0].application_fee.replace("R",""));
          // }
          this.applicationService.putApplication(this.dataCntrl.application)
            .subscribe(result => {
              this.updatePermit(this.status_id);
              if (this.renewFlag) {
                this.toastService.success(`Your Permit Renewal has been submitted successfully.`, `Permit Renewal`);
              } else {
                this.toastService.success(`Your permit application was submitted successfully`, 'Permit Application');
              }
              if (this.renewFlag) {
                this.router.navigate(['carrier/permit/application/' + this.renewCrId]);
              } else {
                this.router.navigate(['/carrier/permit/application/' + this.dataCntrl.carrierID]);
              }
              this.pageload = false;
            },
              error => {
                this.pageload = false;
    
                // this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.','Save Application')
    
                // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
                return;
              });
        }
      }
      updatePermit(status_id) {
        this.dataCntrl.permits[0].status_id = status_id;
        if (this.vehicles == null || this.vehicles.length == 0) {
          this.dataCntrl['permits'][0].application_fee = parseFloat(this.dataCntrl['permits'][0].application_fee.replace(/[^\d\.]*/g, ''));
          // this.dataCntrl['permits'][0].permit_fee = parseFloat(this.dataCntrl['permits'][0].permit_fee.replace( /[^\d\.]*/g, ''));
          this.dataCntrl['permits'][0].permit_fee = 0;
        }
        this.permitService.upadatePermit(this.dataCntrl.permit).subscribe(result => {
          this.dataCntrl.permit = result;
          // this.toastr.success('Updated Permit Type Successfully','Permit Type');
          // this.applicationService.setTab(2);
    
        })
    
      }
      downloadPdf() {
        var img = new Image()
        img.src = '/assets/banner1.png';
        let doc = new jsPDF('p', 'pt');
        // doc.addImage(img, 'png', 0, 0, 220, 50);
        // doc.fromHTML($("#confirm-content-1").html(), 10, 50, {
        //   width: 500
        //   });
        let header: any = ["", ""];
        let createdDate: any = this.dataCntrl['application'].date_created.split("T")[0];
        let content = [
          ["Proforma Invoice and Confirmation", ""],
          ["Invoice:", this.invoiceNumber],
          ["Permit Application No:", this.dataCntrl.carrier.carrier_code],
          ["Application Date:", createdDate],
          ["Applicant:", this.userDetails.FirstName + " " + this.userDetails.LastName],
          ["Email:", this.dataCntrl['carrier'].email]
        ];
        let content1 = [
          ["Physical Address", ""],
          ["Address Line:", this.dataCntrl['carrier'].physical_address_1],
          ["Town:", this.dataCntrl['carrier'].physical_address_town],
          ["Post Codee:", this.dataCntrl['carrier'].physical_post_code],
          ["Country:", this.dataCntrl['carrier'].country]
        ];
        let content2 = [
          ["Account Balance", this.dataCntrl['carrier'].account_balance]
        ];
        let header2: any = ["", "", ""]
        let header1: any = ["Vehicle Registration", "Vehicl Type", "Start Date", "Permit Type", "Duration", "Application Fee", "Permit Fee", "Line Total"]
        let content3 = [];
        let content4 = [["", "Total", this.totalFee]];
        let content5 = [["Fees shown in red are due on submission of the application. The remaining fee(s) if any will be payable before any permit is issued.These fees could change latter", "Payable on submission", this.submissionAmt]];
        let content6 = [["", "Amount Paid", this.paidAmt]];
        let content7 = [["", "Amount Due now", this.dueAmt]];
        for (let list of this.vehicles) {
          let duration: any = "";
          if (this.dataCntrl['permittype'].permit_years > 0) {
            duration = this.dataCntrl['permittype'].permit_years + (this.dataCntrl['permittype'].permit_years == 1? "- year" : "- years");
          }
          if (this.dataCntrl['permittype'].permit_months > 0) {
            duration = this.dataCntrl['permittype'].permit_months + (this.dataCntrl['permittype'].permit_months == 1? "- month" : "- months");
          }
          if (this.dataCntrl['permittype'].permit_days > 0) {
            duration = this.dataCntrl['permittype'].permit_dayss + (this.dataCntrl['permittype'].permit_dayss == 1? "- day" : "- days");
          }
          let obj: any = [list.registration_number, list.vehicle_type, list.start_date, this.dataCntrl['permittype'].description, duration, this.dataCntrl['permits'][0].application_fee,
          this.dataCntrl['permits'][0].permit_fee, this.lineTotal];
          content3.push(obj);
        }
        let startingpage = doc.internal.getCurrentPageInfo().pageNumber;
        //doc.text("Proforma Invoice and Confirmation");
        doc.setFontSize(10);
        doc.autoTable(header, content, {
          showHeader: 'firstPage',
          avoidPageSplit: true,
          theme: 'plain',
          margin: { top: 20, right: 305 },
          styles: { fontSize: 10, overflow: 'linebreak', columnWidth: 'wrap' },
          columnStyles: {
            0: { columnWidth: 165 }
          }
        });
        doc.setPage(startingpage);
        doc.autoTable(header, content1, {
          showHeader: 'firstPage',
          avoidPageSplit: true,
          theme: 'plain',
          margin: { top: 20, left: 305 },
          styles: { fontSize: 10, overflow: 'linebreak', columnWidth: 'wrap' }
        });
    
        doc.autoTable(header, content2, {
          showHeader: 'firstPage',
          avoidPageSplit: true,
          margin: { top: 80 },
          theme: 'plain',
          startY: doc.autoTableEndPosY() + 20,
          styles: { fontSize: 10, overflow: 'linebreak', columnWidth: 'wrap' },
    
        });
        doc.autoTable(header1, content3, {
          showHeader: 'firstPage',
          avoidPageSplit: true,
          theme: 'plain',
          margin: { top: 80 },
          startY: doc.autoTableEndPosY() + 5,
          styles: { fontSize: 10, overflow: 'linebreak', columnWidth: 'wrap' },
          columnStyles: {
            0: { columnWidth: 80 },
            1: { columnWidth: 60 },
            2: { columnWidth: 60 },
            3: { columnWidth: 90 },
            4: { columnWidth: 60 },
            5: { columnWidth: 60 },
            6: { columnWidth: 60 },
            7: { columnWidth: 60 }
          }
        });
        doc.autoTable(header2, content4, {
          showHeader: 'firstPage',
          avoidPageSplit: true,
          theme: 'plain',
          margin: { top: 80 },
          startY: doc.autoTableEndPosY(),
          styles: { fontSize: 10, overflow: 'linebreak', columnWidth: 'wrap' },
          columnStyles: {
            0: { columnWidth: 370 },
            1: { columnWidth: 100 },
            2: { columnWidth: 100 }
          }
        });
        doc.autoTable(header2, content5, {
          showHeader: 'firstPage',
          avoidPageSplit: true,
          theme: 'plain',
          margin: { top: 80 },
          startY: doc.autoTableEndPosY(),
          styles: { fontSize: 10, overflow: 'linebreak', columnWidth: 'wrap' },
          columnStyles: {
            0: { columnWidth: 370 },
            1: { columnWidth: 100 },
            2: { columnWidth: 100 }
          }
        });
        doc.autoTable(header2, content6, {
          showHeader: 'firstPage',
          avoidPageSplit: true,
          theme: 'plain',
          margin: { top: 80 },
          startY: doc.autoTableEndPosY(),
          styles: { fontSize: 10, overflow: 'linebreak', columnWidth: 'wrap' },
          columnStyles: {
            0: { columnWidth: 370 },
            1: { columnWidth: 100 },
            2: { columnWidth: 100 }
          }
        });
        doc.autoTable(header2, content7, {
          showHeader: 'firstPage',
          avoidPageSplit: true,
          theme: 'plain',
          margin: { top: 80 },
          startY: doc.autoTableEndPosY(),
          styles: { fontSize: 10, overflow: 'linebreak', columnWidth: 'wrap' },
          columnStyles: {
            0: { columnWidth: 370 },
            1: { columnWidth: 100 },
            2: { columnWidth: 100 }
          }
        });
        this.sendConfirmMail(doc);
        doc.save('PermitApplication.pdf');
      }
    
    
      cancelApplication() {
        let prevUrl = localStorage.getItem('previousUrl');
        if (prevUrl.search('/permit/approval') != -1) {
          this.router.navigate(['/permit/approval/']);
        } else if (prevUrl.search('/carrier/permit/application/mypermits') != -1) {
          this.router.navigate(['/carrier/permit/application/mypermits/',this.dataCntrl.carrierID]);
        } else {
          this.router.navigate(['/carrier/permit/application/',this.dataCntrl.carrierID]);
        }
      }
        // if (this.dataCntrl.application.id == undefined && this.dataCntrl.application.id == null) {
          // this.router.navigate(['/carrier/permit/application/' + this.dataCntrl.carrierID]);
        // } else {
        //   this.showModal.showYesNo('Delete Application', 'Are you sure you want to delete?', `You're about to delete application`, 'Yes', 'No')
        //     .subscribe((isConfirmed) => {
        //       if (isConfirmed) {
        //         this.deleteApplication()
        //       } else {
        //         return;
        //       }
        //     });
        // }
      // }
    
      deleteApplication() {
        this.pageload = true;
    
        this.permitService.deletePermit(this.dataCntrl.permits[0].id).subscribe(x => {
          this.deleteApp(this.dataCntrl.appID);
          this.pageload = false;
    
          this.router.navigate(['/carrier/permit/application/' + this.dataCntrl.carrierID]);
    
        })
        //this.dataCntrl.application.id
        //this.dataCntrl.permits[0].id
      }
      deletePermit(id) {
        this.permitService.deletePermit(id).subscribe(x => {
        })
    
      }
      formatCurrency(value) {
        return accounting.formatMoney(value, 'R', 2, ' ', '.');
      }
      deleteApp(id) {
        this.applicationService.deleteApplication(id).subscribe(x => {
        })
      }
      disbledBtn() {
        let dueAmt: any = 0;
        if (!this.termsFlag && !this.isCompletePayment) {
          this.hasCredit= true;
        } else {
          // if (this.vehicles.length > 0) {
            let acntBal: any = 0;
            if (this.dataCntrl['carrier'].account_balance != null) {
              acntBal = (this.dataCntrl['carrier'].account_balance).toString().replace(/\s+/g, "");
              acntBal = acntBal.replace("R", "");
              //acntBal = parseFloat(acntBal.replace("-", ""));
            }
            //
            if (this.dueAmt != null && this.dueAmt != undefined && this.dueAmt != "") {
              dueAmt = this.dueAmt.replace(" ", "");
              dueAmt = parseFloat(dueAmt.replace("R", ""));
            }
            //alert(acntBal + ' < ' + dueAmt);
            if (acntBal < dueAmt) {
              this.hasCredit= false;
            
          } else {
            this.hasCredit= true;
          }
        }
        
          if(this.dueAmt < 1){
            this.hasCredit= false;
          }
          // else{
          //   this.hasCredit= true;
          // }
      
      }
     

      UpdateComplianceTransactions(){
        // alert(this.dataCntrl.application.compliance.id);
        // alert(this.dataCntrl.application.complianceDetail.id);
        this.complianceService.updateComplianceCertificateTransaction(this.dataCntrl.application.compliance.id, this.dataCntrl.application.complianceDetail.id).subscribe(res =>{
          console.log("compliance updated   " + res);
        });

      }
    
     
    
      sendConfirmMail(pdfDoc) {
        let payload: any = Object();
        payload['carrier_id'] = this.dataCntrl.carrierID;
        payload['application_id'] = this.dataCntrl.application.id;
        payload['document_id1'] = null;
        payload['document_id2'] = null;
        payload['document_id3'] = null;
        payload['corspdc_type_ind'] = 2;
        payload['body_text'] = null;
        payload['notes'] = null;
        payload['attachment'] = pdfDoc.output('datauri');
        payload['subject'] = 'Permit Application';
        payload['send_receive_ind'] = 1;
        payload['comm_type_ind'] = 1;
        payload['num_bookmarks'] = 1;
        payload['date_created'] = new Date();
        payload['date_modified'] = new Date();
        payload['user_created'] = new Date();
        payload['user_modified'] = new Date();
        payload['bookmark1_value'] = null;
        payload['bookmark2_value'] = null;
        payload['bookmark3_value'] = null;
        payload['bookmark4_value'] = null;
        payload['bookmark5_value'] = null;
        payload['bookmark6_value'] = null;
        payload['from_person_id'] = this.dataCntrl.carrier.person_id;
        payload['correspondence_person'] = [this.dataCntrl.carrier.person_id];
        payload['file_name'] = 'PrmitAppliaction';
        this.crspdService.sendMail(payload).subscribe(res => {
          this.toastService.success(`Your permit application was submitted successfully`, 'Permit Application');
          if (this.renewFlag) {
            this.router.navigate(['carrier/permit/application/renew/' + this.renewCrId]);
          } else {
            this.router.navigate(['/carrier/permit/application/' + this.dataCntrl.carrierID]);
          }
        })
      }
    
      getUpdateBalance() {
        this.carrierService.getUpdateBalance(this.dataCntrl.carrier.carrier_account_id).subscribe(res => {
    
        })
      }
      sendCorr(ind) {
        let body_text = environment.authWebApi.systemData.Configurations.find(config => config.Code == "SubmitEmail2").Value;
    
        let payload: any = Object();
        payload['carrier_id'] = this.dataCntrl.carrierID;
        payload['application_id'] = this.dataCntrl.application.id;
        payload['permit_id'] = this.dataCntrl.permits[0].id;
        payload['document_id1'] = null;
        payload['document_id2'] = null;
        payload['document_id3'] = null;
        payload['corspdc_type_ind'] = 2;
        payload['body_text'] = body_text;
        payload['notes'] = null;
        payload['attachment'] = null;
        payload['subject'] = 'Permit Application';
        if (ind === 0) {
          payload['send_receive_ind'] = 11;
    
        } else {
          payload['send_receive_ind'] = ind;
        }
        payload['comm_type_ind'] = 1;
        payload['num_bookmarks'] = 0;
        payload['date_created'] = new Date();
        payload['date_modified'] = new Date();
        payload['user_created'] = this.userDetails.FirstName;
        payload['user_modified'] = this.userDetails.FirstName;
        payload['bookmark1_value'] = null;
        payload['bookmark2_value'] = null;
        payload['bookmark3_value'] = null;
        payload['bookmark4_value'] = null;
        payload['bookmark5_value'] = null;
        payload['bookmark6_value'] = null;
        payload['from_person_id'] = this.dataCntrl.carrier.person_id;
        payload['correspondence_person'] = [this.dataCntrl.carrier.person_id];
        payload['file_name'] = null;
        this.crspdService.sendMail(payload).subscribe(data => {
    
        }, error => {
    
        })
    
      }

      getAllPermitsByApplicationId(): Promise<any>
      {
        //alert(this.applicationId)
        return this.permitSevc.getAllPermitsByApplicationId(this.applicationId).toPromise();
      }
      getPermitsAppVecle() : Promise<any>
      {
        return this.vehicleService.getPermitsAppVecle(this.applicationId).toPromise();
      }

      async getSavedVehicleByPermit() {
        //alert('getSavedVehicleByPermit');
        this.myLoader = true;
        this.pageload = true;
        this.listvehicles = [];
        this.vehicles=[];

        this.vehicleService.getByPermitId(this.dataCntrl['permits'][0].id).subscribe(vehicles =>{
            //alert(JSON.stringify(vehicles));
               let vehicle:any = vehicles;
                    let object = {
                      id: vehicle.id,
                      vehicle_type_id: vehicle.vehicle_type_id,
                      vehicle_make_id: vehicle.vehicle_make_id,
                      vehicle_make: vehicle.vehicle_make,
                      vehicle_type: vehicle.vehicle_type,
                      is_current: false,
                      registration_number: vehicle.registration_number,
                      // seating_capacity:vehicle.seating_capacity,
                      number_passengers: vehicle.number_passengers,
                      gvn: vehicle.gvn,
                      vin: vehicle.vin,
                      date_license_expiry: this.datePipe.transform(vehicle.date_license_expiry, 'dd/MM/yyyy'),
                      start_date: this.datePipe.transform(new Date(), 'dd/MM/yyyy'),
                      editMode: false
                    }
    
                  // alert(JSON.stringify(object));
                    this.listvehicles.push(object);
                    this.pageload = false;
    
                
    
                this.pageload = false;
                this.dataCntrl.vehicles = this.vehicles = this.listvehicles;
                
            
            this.populateData();
          //   this.count = this.count++;
             this.myLoader = false;
    
          // }, 4000);
          //}
    
          return true;
    
        
    
      });
      }
      async populateData() {
        //alert('populateData');
        //if (this.count == 0) {
          this.pageload = true;
    
          this.count = this.count + 1;
          this.paidAmt = 0;
          this.dueAmt = 0;
          this.submissionAmt = 0;
    
          if (this.dataCntrl.vehicles == null || this.dataCntrl.vehicles == undefined) {
            this.dataCntrl.vehicles = [];
          }
    
          // Paid Amount
          // No Paid Amount
         // alert(this.isView);
          if(this.isView == true)
          {
            if (this.dataCntrl['permits'][0].application_invoice_link != null && (this.dataCntrl['permits'][0].application_invoice_link).substring(0,3) == "INV") {
              
              if (this.dataCntrl.vehicles.length == 0) {
                this.paidAmt = this.application_fee
              } else {
                this.paidAmt = this.application_fee * this.dataCntrl.vehicles.length;
              }       
            }
            if (this.dataCntrl['permits'][0].permit_invoice_link != null && (this.dataCntrl['permits'][0].permit_invoice_link).substring(0,3) == "INV") {
              
              if (this.dataCntrl.vehicles.length == 0) {
                this.paidAmt = this.paidAmt + this.permit_fee
              } else {
                this.paidAmt = this.paidAmt + this.permit_fee * this.dataCntrl.vehicles.length;
              }
            }
          }
    
          // Total Fee
          this.totalFee = (this.application_fee + this.permit_fee);
          if (this.vehicles == null || this.vehicles.length == 0) {
            this.totalFee = this.application_fee;
            this.lineTotal = this.application_fee;
          }
          //console.log(this.dataCntrl['permits'][0].application_fee   + 'fee')
    
          this.lineTotal = (parseFloat(this.application_fee + parseFloat(this.permit_fee)));
          this.lineTotal = this.formatCurrency(this.lineTotal);
    
          // charge_when_ind
          if (this.isCompletePayment == true && this.dataCntrl['permits'][0].renewal_num > 0) {
            this.chargeInd = 2;
          } else {
            this.chargeInd = this.dataCntrl['permittype'].charge_when_ind;
          }
    
          if ((this.vehicles == null || this.vehicles.length == 0) && (this.chargeInd == 1)) {
            this.dueAmt = this.application_fee - this.paidAmt;
            this.submissionAmt = this.application_fee;

          }
         this.totalFee = this.formatCurrency(this.totalFee);
          // Application Fee Only
          if ((this.chargeInd == 1) && this.vehicles.length > 0) {

            this.submissionAmt = this.application_fee * this.vehicles.length
            if (this.dataCntrl['application'].status_id == this.permitStatus13 || this.dataCntrl['application'].status_id == this.permitStatus14) {
              this.dueAmt = this.permit_fee * this.vehicles.length;
            } 
            else if (this.dataCntrl['permits'][0].permit_invoice_link != null && (this.dataCntrl['permits'][0].permit_invoice_link).substring(0,3) == "INV") {
              if(this.dataCntrl.compID == null || this.dataCntrl.compID == undefined)
              {
              this.dueAmt = this.submissionAmt + this.permit_fee;
              }else{
                this.dueAmt = this.permit_fee;
              }
              this.paidAmt = 0
            } 
            else {
              //console.log(this.dueAmt + "   " + " " + this.dataCntrl['permits'][0].permit_fee);
              this.dueAmt = this.submissionAmt - this.paidAmt;
            }
          }
          // Application & Permit Fee
           if (this.chargeInd == 2 && this.vehicles.length > 0) {
        this.submissionAmt = (this.application_fee * this.vehicles.length) + (this.permit_fee * this.vehicles.length);
        this.dueAmt = this.submissionAmt - this.paidAmt;
      }
      this.application_fee = this.formatCurrency(this.application_fee);
      this.permit_fee = this.formatCurrency(this.permit_fee)

      this.submissionAmt = this.formatCurrency(this.submissionAmt);
      this.paidAmt = this.formatCurrency(this.paidAmt);
      this.dueAmt = this.formatCurrency(this.dueAmt);

      this.pageload = false;
        //alert("pop done");
      }
      getVehicleMake() {
        this.vehicleMakeService.getAll().subscribe((result: any) => {
          this.list_vehicle_make = result
          this.selectedVMake = result.find(x => x.code == 'Unknown');
        }, error => {
    
        });
      }

      SubmitApplication()
      {


        // this.showModal.showYesNo('Confirm Application', `Are you sure you want to submit application for a Permit ?. A confirmation email will be sent to '${this.userDetails.EmailAddress}'.`, `Please access your Portal for next steps.`, 'Ok', 'Cancel')
        //     .subscribe((isConfirmed) => {
        //       if(isConfirmed) {
        //         //this.determineStatus();
        //         this.newStatus = 74;
        //         this.saveConfirmation(this.newStatus);                
        //       }
        //       else
        //       {
        //         return;
        //       }
        //     }
        //   );
          this.confirmDialogService.confirmThis(`Are you sure you want to submit application for a Permit ?. A confirmation email will be sent to '${this.userDetails.EmailAddress}'.`, () => {  
          
            this.newStatus = 74;
            this.saveConfirmation(this.newStatus);
      
          }, () =>  {  
            return;
          }) 
      }


      saveApplication() {
        let object: any = Object();
        object['date_modified'] = this.dataCntrl.application.date_modified;
        object['user_modified'] = this.dataCntrl.application.user_modified;
        object['reference_num'] = this.dataCntrl.application.reference_num;
        object['permit_type_id'] = this.dataCntrl.application.permit_type_id;
        object['person_id'] = this.dataCntrl.application.person_id;
        object['carrier_id'] = this.dataCntrl.application.carrier_id;
        object['date_created'] = this.dataCntrl.application.date_created;
        object['user_created'] = this.dataCntrl.application.user_created;
        let oldResult: any = this.dataCntrl.application;
        this.applicationService.postApplication(object)
          .subscribe(result => {
            this.savePermit(result);
          });
      }
      updatePermitRenew() {
        if (this.dataCntrl.permits[0].renewal_num == null) {
          this.dataCntrl.permits[0].renewal_num = 1;
        } else {
          this.dataCntrl.permits[0].renewal_num = parseInt(this.dataCntrl.permits[0].renewal_num) + 1;
        }
        this.permitService.upadatePermit(this.dataCntrl.permit)
          .subscribe((result:any) => {
            result.renewal_num = this.dataCntrl.permits[0].renewal_num;
            this.dataCntrl.permit = result;
          });
      }
      savePermit(data) {

        this.updatePermitRenew();
        let permitObject: any = JSON.parse(JSON.stringify(this.dataCntrl.permit));
        permitObject.permit_type_id = this.Compliance_PermitType_Id;
        if (this.dataCntrl.compID != null || this.dataCntrl.compID != undefined)
        {
          permitObject.application_id = this.dataCntrl.application.id;
        }
        else{
        permitObject.application_id = data.id;
        }
        permitObject.date_modified = this.dataCntrl.permits[0].date_created = new Date();
        permitObject.user_modified = this.dataCntrl.permits[0].user_created = environment.authWebApi.userData.User.FirstName;
        permitObject.permit_fee = this.dataCntrl.permittype.current_fee == null ? 0 : this.dataCntrl.permittype.current_fee;
        permitObject.application_fee = this.dataCntrl.permittype.current_application_fee == null ? 0 : this.dataCntrl.permittype.current_application_fee;
        permitObject.status_id = 11;
        permitObject.date_11 = null;
        //permitObject.renewal_num=0;
        // permitObject.date_11=newDate2;
        permitObject.date_valid_from = null;
        permitObject.date_valid_to = null;
        permitObject.number_passengers = this.vehicles[0].number_passengers;
        this.permitService.postPermit(permitObject)
          .subscribe(result => {
            this.saveVehicles(result, data);
          });
      }
      saveVehicles(data, application) {
        let count: any = 0;
        for (let item of this.vehicles) {
          let newDate1;
          if (!item.date_license_expiry) {
            item.date_license_expiry = null;
          }
          if (!item.start_date) {
            item.start_date = null;
          }
          if (item.date_license_expiry != null) {
            let date = item.date_license_expiry.split('/');
            let day = parseInt(date[0], 10);
            let month = parseInt(date[1], 10);
            let year = parseInt(date[2], 10);
            let newDate = year + '/' + month + '/' + day;
            newDate1 = new Date(newDate);
            newDate1.setDate(newDate1.getDate() + 1);
          }
          let newDate2;
          if (item.start_date != null) {
            let date2 = item.start_date.split('/');
            let day2 = parseInt(date2[0], 10);
            let month2 = parseInt(date2[1], 10);
            let year2 = parseInt(date2[2], 10);
            let newDate10 = year2 + '/' + month2 + '/' + day2;
            newDate2 = new Date(newDate10);
            newDate2.setDate(newDate2.getDate() + 1);
    
          }
          let newDatepm: any = null;
          if (this.dataCntrl.permits[0].date_valid_to != null) {
            let parseDate: any = this.dataCntrl.permits[0].date_valid_to.split("T")[0];
            newDatepm = new Date(Date.parse(parseDate + " EDT"));
            newDatepm.setDate(newDatepm.getDate() + 1);
            newDatepm = newDatepm.toISOString();
          }
    
    
          let object = {
            id: "-1",
            vehicle_type_id: item.vehicle_type_id,
            vehicle_type: item.vehicle_type,
            vehicle_make_id: this.selectedVMake.id,
            vehicle_make: this.selectedVMake.description,
            is_current: true,
            registration_number: item.registration_number,
            number_passengers: item.number_passengers,
            gvn: item.gvn,
            vin: item.vin,
            permit_id: 0,
            date_license_expiry: newDate1,
            start_date: newDate2,
            date_modified: new Date(),
            date_created: new Date(),
            user_modified: item.user_created = environment.authWebApi.userData.User.FirstName,
            editMode: true
          }
          if (count == 0) {
            data.date_11 = newDatepm;
            this.permitService.upadatePermit(data).subscribe((res:any) => {
              object.permit_id = res.id
              this.vehicleService.updateVehicle(object).subscribe(result => {
              });
            });
          } else {
            data.date_11 = item.start_date;
            data.date_valid_to = null;
            data.date_valid_from = null;
            data.number_passengers = item.number_passengers;
            this.permitService.postPermit(data).subscribe((result:any) => {
              //  this.dataCntrl.permit = result;
              object.permit_id = result.id
              this.vehicleService.updateVehicle(object).subscribe(result => {
              });
            });
          }
          count++;
        }
        this.saveRoutes(data, application);
      }
      getRoutes() {
        this.routeService.getDoNotBelong().subscribe((rts: any) => {
          this.ownRoutes = rts.filter(x => x.user_created == environment.authWebApi.userData.User.FirstName);
        });
      }
      saveRoutes(data, app) {
        this.routeService.getMyRoute(this.dataCntrl.application.route_id).subscribe((route: any) => {
    
          let id = this.ownRoutes.filter((map) => { return map.description == route.description });
          let routes: any = {
            id: id[0].id,
            code: route.code.split("-")[0] + "-" + app.id,
            route_detail: route.route_detail,
            description: route.description,
            route_summary: route.route_summary,
            // num_countries:this.form.value.num_countries,
            // num_border_crossings:this.form.value.num_border_crossings,
            user_created: environment.authWebApi.userData.User.FirstName,
            user_modified: environment.authWebApi.userData.User.FirstName,
            date_created: new Date(),
            date_modified: new Date(),
          }
          this.routeService.saveRouteAndRouteLeg(routes).subscribe((x: any) => {
            data.route_id = x.id;
            this.permitService.upadatePermit(data)
              .subscribe(result => {
                app.route_id = x.id;
                app.route_summary = this.dataCntrl.application.route_summary;
                app.route_detail = this.dataCntrl.application.route_detail;
                app.motivation_detail = this.dataCntrl.application.motivation_detail;
                this.applicationService.putApplication(app)
                  .subscribe(result => {
                    this.dataCntrl.application = result;
                    this.dataCntrl.carrier.id = this.renewCrId;
                    this.updateConfm(this.permitStatus6);
                  });
              });
          });
        });
      }
      backToTab() {
        const tabNum = this.utility.tabPosition(this.utility.sequenceNumbers.cnfNum);
        this.applicationService.setTab(1);
        //this.applicationService.setTab(5);
      }
      backtoApp(){
        this.applicationService.setTab(1);
        // this.router.navigate(['/carrier/permit/application/',this.dataCntrl.carrierID]);
        // let prevUrl = localStorage.getItem('previousUrl');
        // if (prevUrl.search('/permit/approval') != -1) {
        //   this.router.navigate(['/permit/approval/']);
        // } else if (prevUrl.search('/carrier/permit/application/mypermits') != -1) {
        //   this.router.navigate(['/carrier/permit/application/mypermits/',this.dataCntrl.carrierID]);
        // } else {
        //   this.router.navigate(['/carrier/permit/application/',this.dataCntrl.carrierID]);
        // }
      }
    
      //New updateConfirm
      updateConfm(permitStatus) {
        this.pageload = true;
        if (!this.termsFlag) {
          this.pageload = false;
          return this.toastr.warning('Please agree the terms', 'Terms');
        }
        const config: any = environment.authWebApi.systemData.Configurations.find(config => config.Code == "SubmitEmail2");
    
        let payload: any = Object();
        payload['carrier_id'] = this.dataCntrl.carrierID;
        payload['application_id'] = this.dataCntrl.application.id;
        payload['permit_id'] = this.dataCntrl.permits[0].id;
        payload['document_id1'] = null;
        payload['document_id2'] = null;
        payload['document_id3'] = null;
        payload['corspdc_type_ind'] = 3;
        payload['body_text'] = config.Value;
        payload['notes'] = null;
        payload['attachment'] = null;
        payload['subject'] = config.Description;
        payload['send_receive_ind'] = 11;
        payload['comm_type_ind'] = 3;
        payload['num_bookmarks'] = 0;
        payload['date_created'] = new Date();
        payload['date_modified'] = new Date();
        payload['user_created'] = this.userDetails.FirstName;
        payload['user_modified'] = this.userDetails.FirstName;
        payload['bookmark1_value'] = null;
        payload['bookmark2_value'] = null;
        payload['bookmark3_value'] = null;
        payload['bookmark4_value'] = null;
        payload['bookmark5_value'] = null;
        payload['bookmark6_value'] = null;
        //payload['from_person_id'] = this.dataCntrl.carrier.person_id;
        //payload['correspondence_person'] = [this.dataCntrl.carrier.person_id];
        payload['file_name'] = null;
        payload['action'] = 'SaveComplianceApp';
        ////console.log('Application data : ', payload)
        // this.permitService.UpdatePermitNum(this.dataCntrl.permits[0].id).subscribe(data => {
        // });
        let oldAppID = this.dataCntrl.application.id;
        if (this.permitRenewal == false) {
          if(localStorage.getItem("oldAppId")){
            if(this.router.url.indexOf('correction') > 0 || this.router.url.indexOf('duplicate') > 0 || this.router.url.indexOf('vehicle') > 0 || this.router.url.indexOf('change') > 0){
              oldAppID = parseInt(localStorage.getItem("oldAppId"));
            //console.log(oldAppID)
            }
          }
        }
        if(this.dataCntrl.compID != null || this.dataCntrl.compID != undefined)
        {
          oldAppID = this.dataCntrl.appID;
        }
        this.crspdService.savePermitCorrespondence(payload,oldAppID,permitStatus, true).subscribe((data:any) => {
         // alert(100);
          this.pageload = false;
          //this.isLoading = false;
          ////console.log('Correspondence : ', data);
          if (data.isSaved == "Success") {
            this.toastService.success(`Your permit application was submitted successfully`, 'Permit Application');
            this.router.navigate(['/carrier/compliance/return/list/' + this.dataCntrl.carrierID + '/0']);
            
          } else {
            this.toastService.error(`Error during permit confirmation. The server error response message : ${data.isSaved}`, `ERROR : Confirmation`);
          }
        }, error => {
          this.pageload = false;
          //this.isLoading = false;
          this.toastService.error(`Error during permit confirmation. The server responded with error code "${error.status} : ${error.statusText}""`, `ERROR : Confirmation`);
          // this.toastr.error(`Submission for ${this.dataCntrl['carrier'].name}  failed.Please contact the system administrator if the problem persists.`, `Confirmation`);
        })
    
    
      }
    
      getOldStartDate() {
        // BUG : 121
        // all we have to work with is he old application number from local storage
        let appId: string = localStorage.getItem("oldAppId");
        let perm_num:any = this.dataCntrl.permits[0].permit_num;
        // ...so we retieve all the vehicles for this application
        this.vehicleService.getPermitsAppVecle(this.dataCntrl.appID).subscribe((result:any) => {
          // ...then we loop through them all
          result.forEach(perm => {
            this.permitService.getById(perm.permit_id).subscribe((vehcle:any) => {
              if (perm_num == vehcle.permit_num) {
                this.dataCntrl.oldPermitStartDate=perm.start_date;
              }
            });
          });
        });
      }
         
}